import { render } from "./SegmentControl.vue?vue&type=template&id=b9edc8bc"
import script from "./SegmentControl.vue?vue&type=script&lang=js"
export * from "./SegmentControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__